import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Testimonials from "./pages/Testimonials";
import Socials from "./pages/Socials";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import OfficeFitOutSouthEast from "./pages/seo/OfficeFitOutSouthEast";
import OfficeRefurbishment from "./pages/seo/OfficeRefurbishment";
import OfficePartitioning from "./pages/seo/OfficePartitioning";
import CommercialFitOut from "./pages/seo/CommercialFitOut";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 overflow-x-hidden">
        <Navbar />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/socials" element={<Socials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/office-fit-out-south-east" element={<OfficeFitOutSouthEast />} />
            <Route path="/office-refurbishment" element={<OfficeRefurbishment />} />
            <Route path="/office-partitioning" element={<OfficePartitioning />} />
            <Route path="/commercial-fit-out" element={<CommercialFitOut />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
